<template>
  <div class="bg">
    <div class="content">
      <el-card>
        <el-row>
          <el-col :span="24">
            <span> 所属项目：{{ projectName }} </span>
          </el-col>
          <el-col :span="24">
            <span> 许可名称：{{ detailInfo.name }} </span>
          </el-col>
          <el-col :span="24">
            <span> 许可编号：{{ detailInfo.code }} </span>
          </el-col>
          <el-col :span="24">
            <span> 备注信息：{{ detailInfo.remark }} </span>
          </el-col>
        </el-row>
      </el-card>
    </div>
  </div>
</template>
<script>
import { postProjectId } from "@/api/app/project";
import { postDetail } from "@/api/app/builderLicenses";
export default {
  data() {
    return {
      detailInfo: {},
      projectName: "",
    };
  },
  created() {
    this.detail();
  },

  methods: {
    detail() {
      // 通过参建单位id获取详细信息
      postDetail(this.$store.state.app.itemId).then((res) => {
        this.detailInfo = res.data;
        postProjectId(res.data.projectId).then((a) => {
          this.projectName = a.data.name;
        });
      });
    },
  },
};
</script>
<style lang="less" scoped>
.bg {
  margin-bottom: 50px;
  padding: 10px;
  min-height: 100vh;
  background-color: #f0f0f0;
}
.content {
  font-size: 14px;
  .el-form-item {
    margin: 0px;
    font-size: 14px;
  }
  p {
    i {
      font-size: 12px;
    }
  }
  /deep/ .el-input__inner {
    border: unset;
    padding: 0;
  }
}
</style>
